import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_4 = { class: "me-7 mb-4" }
const _hoisted_5 = {
  class: "image-input image-input-outline",
  "data-kt-image-input": "true",
  style: {"background-image":"url(media/avatars/blank.png)"}
}
const _hoisted_6 = {
  class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
  "data-kt-image-input-action": "change",
  "data-bs-toggle": "tooltip",
  title: "Change avatar"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-fill fs-7" }, null, -1)
const _hoisted_8 = {
  id: "kt_account_profile_photo_update",
  class: "form"
}
const _hoisted_9 = {
  key: 0,
  class: "badge badge-light-success align-middle fw-bolder mt-2 fs-8 py-1 w-125px"
}
const _hoisted_10 = {
  key: 1,
  class: "badge badge-light-danger align-middle fw-bolder mt-2 fs-8 py-1 w-125px"
}
const _hoisted_11 = { class: "flex-grow-1" }
const _hoisted_12 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_13 = { class: "d-flex flex-column" }
const _hoisted_14 = { class: "d-flex align-items-center mb-2" }
const _hoisted_15 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fs-2 fw-bolder me-1"
}
const _hoisted_16 = { href: "#" }
const _hoisted_17 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_18 = { class: "d-flex flex-wrap fw-bold fs-6 mb-4 pe-2" }
const _hoisted_19 = {
  key: 0,
  class: "d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
}
const _hoisted_20 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_21 = {
  href: "#",
  class: "d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
}
const _hoisted_22 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_23 = {
  href: "#",
  class: "d-flex align-items-center text-gray-400 text-hover-primary mb-2"
}
const _hoisted_24 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex my-4" }, null, -1)
const _hoisted_26 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column flex-grow-1 pe-8" }, null, -1)
const _hoisted_28 = { class: "d-flex align-items-center w-200px w-sm-300px flex-column mt-3" }
const _hoisted_29 = { class: "d-flex justify-content-between w-100 mt-auto mb-2" }
const _hoisted_30 = { class: "fw-bold fs-6 text-gray-400" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6" }, "50%", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "h-5px mx-3 w-100 bg-light mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "bg-success rounded h-5px",
    role: "progressbar",
    style: {"width":"50%"},
    "aria-valuenow": "50",
    "aria-valuemin": "0",
    "aria-valuemax": "100"
  })
], -1)
const _hoisted_33 = { class: "d-flex overflow-auto h-55px" }
const _hoisted_34 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_35 = { class: "nav-item" }
const _hoisted_36 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: "image-input-wrapper w-125px h-125px",
                style: _normalizeStyle(`background-image: url(${_ctx.currentAvatar})`)
              }, null, 4),
              _createElementVNode("label", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("form", _hoisted_8, [
                  _createElementVNode("input", {
                    type: "file",
                    name: "photo",
                    onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updatePhoto && _ctx.updatePhoto(...args))),
                    accept: ".png, .jpg, .jpeg"
                  }, null, 32)
                ])
              ]),
              (_ctx.updatedPhoto)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.t('editProfile.updatedPhoto')), 1))
                : _createCommentVNode("", true),
              (_ctx.photoError)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.t('editProfile.updatePhotoError')), 1))
                : _createCommentVNode("", true),
              _withDirectives(_createVNode(_component_el_progress, {
                class: "w-175px",
                percentage: _ctx.uploadPercentage,
                color: _ctx.customColorMethod
              }, null, 8, ["percentage", "color"]), [
                [_vShow, _ctx.uploadPercentage != 0]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("a", _hoisted_15, _toDisplayString(_ctx.currentUser.employee.firstName) + " " + _toDisplayString(_ctx.currentUser.employee.lastName), 1),
                  _createElementVNode("a", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen026.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  (
                    _ctx.currentUser.employee.position &&
                    _ctx.currentUser.employee.position.name
                  )
                    ? (_openBlock(), _createElementBlock("a", _hoisted_19, [
                        _createElementVNode("span", _hoisted_20, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com006.svg" })
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.currentUser.employee.position.name), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("a", _hoisted_21, [
                    _createElementVNode("span", _hoisted_22, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen018.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.currentUser.employee.adress), 1)
                  ]),
                  _createElementVNode("a", _hoisted_23, [
                    _createElementVNode("span", _hoisted_24, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com005.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.currentUser.speciality), 1)
                  ])
                ])
              ]),
              _hoisted_25
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.t('editProfile.profileCompletion')), 1),
                  _hoisted_31
                ]),
                _hoisted_32
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("ul", _hoisted_34, [
            _createElementVNode("li", _hoisted_35, [
              _createVNode(_component_router_link, {
                to: "/profile/overview",
                class: "nav-link text-active-primary me-6",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('editProfile.general')), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_36, [
              _createVNode(_component_router_link, {
                to: "/profile/settings",
                class: "nav-link text-active-primary me-6",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('editProfile.settings')), 1)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ], 64))
}